import type { NameConfig } from '@libs/items';
import { l10nText } from '@ps-smart-cp/l10n';
import { rawValueToEnum } from '../utils';

/** カスタムフィールドの長さ属性 */
enum CustomFieldLength {
  fixedLength = '1',
  variableLength = '2',
}

const nameConfig: NameConfig<typeof CustomFieldLength> = {
  fixedLength: l10nText({ ja: '固定長', en: 'Has Admin' }),
  variableLength: l10nText({ ja: '可変長', en: 'Not Admin' }),
};

const toEnum = rawValueToEnum(CustomFieldLength, '');

export const customFieldLength = {
  enum: CustomFieldLength,
  nameConfig,
  toEnum,
};
export type { CustomFieldLength };
